export default __webpack_public_path__ + "static/media/lavender-mobile-editor.ce9b918e.png";